/**
 * Retourne les props à appliquer sur un overlay de modal pour le fermer
 * UNIQUEMENT si le clic (mousedown + mouseup) se passe entièrement sur l'overlay,
 * pas quand l'utilisateur fait un drag depuis l'intérieur du modal vers l'extérieur.
 *
 * Usage :
 *   <div {...modalOverlayProps(onClose)}>
 *     <div onMouseDown={e => e.stopPropagation()}>...contenu...</div>
 *   </div>
 */
export function modalOverlayProps(onClose) {
  return {
    onMouseDown: (e) => {
      if (e.target === e.currentTarget) {
        // Le mousedown est sur l'overlay → on marque l'intention de fermer
        e.currentTarget._closeOnMouseUp = true;
      }
    },
    onMouseUp: (e) => {
      if (e.currentTarget._closeOnMouseUp && e.target === e.currentTarget) {
        onClose();
      }
      if (e.currentTarget) e.currentTarget._closeOnMouseUp = false;
    },
  };
}
